export const hideIframe = () => {
    const items = document.querySelectorAll('iframe')
    items.forEach((item)=>{
        if(item.style.zIndex === '2147483647'){
            item.style.display = 'none'
        }
    })
}